import React from 'react';
import cl from 'classnames';
import styles from './backButtonStyle.module.scss';

type BackButtonProps = {
  onClick: () => void;
  size?: 'small' | 'medium';
  className?: string;
};

export const BackButton = ({
  onClick,
  size = 'medium',
  className,
}: BackButtonProps) => {
  return (
    <div
      className={cl(styles.button, size === 'small' && styles.small, className)}
      onClick={onClick}
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.46967 6.53033C0.176777 6.23744 0.176777 5.76256 0.46967 5.46967L5.24264 0.696699C5.53553 0.403806 6.01041 0.403806 6.3033 0.696699C6.59619 0.989592 6.59619 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.59619 10.5355 6.59619 11.0104 6.3033 11.3033C6.01041 11.5962 5.53553 11.5962 5.24264 11.3033L0.46967 6.53033ZM12 6.75L1 6.75V5.25L12 5.25V6.75Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default BackButton;
